<ng-container *transloco="let t">
  @if (
    {
      sectionStatus: sectionStatus$ | async,
    };
    as data
  ) {
    <div [formGroup]="sectionFormGroup()" class="row">
      <div class="col">
        <lib-accordion
          [id]="section.id"
          [title]="
            sectionNumber +
            (section.translations?.list['title']
              | translate: activeLang() : section.title)
          "
          [subTitle]="
            showSubTitle
              ? hideValidation()
                ? undefined
                : data.sectionStatus === SectionStatus.Valid
                  ? t('section_success')
                  : data.sectionStatus === SectionStatus.Invalid
                    ? t('section_error')
                    : undefined
              : undefined
          "
          [success]="data.sectionStatus === SectionStatus.Valid"
          [error]="data.sectionStatus === SectionStatus.Invalid"
          [isOpen]="!isCollapsed()"
          [alwaysRender]="renderSection()"
          [bodyWidth]="bodyWidth"
          [previewMode]="previewMode()"
          (collapse)="onCollapse($event)"
        >
          @for (questionRow of section.structure.order; track $index) {
            <div class="row question-row position-relative">
              @for (question of questionRow; track $index) {
                <div class="col-md">
                  <lib-question
                    [questionFormGroup]="questions()[question]"
                    [showQuestion]="true"
                    [followUpLevel]="0"
                    [showAllFollowUps]="showAllFollowUps()"
                    [questionsInRow]="questionRow.length"
                  ></lib-question>
                </div>
              }
            </div>
          }
        </lib-accordion>
      </div>
    </div>
  }
</ng-container>
